import style from "../../../assets/scss/sub/startGuide.module.scss";
import React from "react";
interface Args {
    img: string;
    idx: number;
    title: string;
    children: React.ReactNode;
    containerStyle?: string;
}

export function StartGuideOptions(
    {img, idx, title, children, containerStyle}: Args
) {
    const containerClassName = containerStyle ? style[containerStyle] || '' : '';

    return (
        <div className={`${style.processTextContainer} ${containerClassName}`}>
            <img className={style.imageStyle} src={img} alt={img}/>
            <div className={style.processStep}>
                <div className={style.processHeader}>
                    <p className={style.stepNumber}>
                        <span className={style.firstLetter}>0</span>
                        <span>{idx}</span>
                    </p>
                    <p className={style.stepTitle}>{title}</p>
                </div>
                <div className={style.verticalBar}></div>
                <div className={style.ulContainer}>
                    {children}
                </div>
            </div>
        </div>
    )
}